import React from 'react';

export default function IndexSectionHeadersWhitePattern1() {
    const addScript = () => {
        const script = document.createElement('script');
        script.src = "https://at-digitalsolutions.activehosted.com/f/embed.php?id=4";
        script.charset = "utf-8";
        document.body.appendChild(script);
    };

    return (
        <React.Fragment>
            <>
                <section className="relative bg-white overflow-hidden" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="py-20 md:py-28">
    <div className="container px-4 mx-auto">
      <div className="flex flex-wrap xl:items-center -mx-4">
        <div className="w-full md:w-1/2 px-4 mb-16 md:mb-0">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-white bg-green-500 uppercase rounded-9xl">FINA-FLOW</span>
          <h1 className="mb-6 text-3xl md:text-5xl lg:text-6xl leading-tight font-bold tracking-tight">FINA</h1>
          <p className="mb-8 text-lg md:text-xl text-coolGray-500 font-medium">Deine digitale Assistentin für Mitarbeitende der Kreditorenbuchhaltung. Als erfahrene Expertin helfe ich dir effizient und verlässlich bei Deinen Herausforderungen.</p>
          <div className="flex flex-wrap">
            <div className="w-full md:w-auto py-1 md:py-0 md:mr-4"><a className="inline-block py-5 px-7 w-full text-base md:text-lg leading-4 text-green-50 font-medium text-center bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 border border-green-500 rounded-md shadow-sm" href="https://at-digitalsolutions.activehosted.com/f/6">Demo anfordern</a></div>
            <div className="w-full md:w-auto py-1 md:py-0" />
          </div>
        </div>
        <div className="w-full md:w-1/2 px-4">
          <div className="relative mx-auto md:mr-0 max-w-max">
            <img className="absolute z-10 -left-14 -top-12 w-28 md:w-auto" src="flex-ui-assets/elements/circle3-yellow.svg" alt />
            <img className="absolute z-10 -right-7 -bottom-8 w-28 md:w-auto" src="flex-ui-assets/elements/dots3-blue.svg" alt />
            <img className="relative rounded-7xl" src="https://static.shuffle.dev/uploads/files/74/74d816bee2c29a5d66e5f8e50d060dc2753d3889/Fina.webp" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}
